import { ReactElement } from "react";
import "../../css/TeeStyles.css";

interface content {
  content: string;
}
const SectionOne = ({ content }: content): ReactElement => {
  return (
    <div data-aos="fade-right" className="my-image-about section">
      <span className="d-block text-center mcm-padding  section boldSeven white fontSize64px">
        {content}
      </span>
    </div>
  );
};

export default SectionOne;
